import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchEquipment = (equipmentId) => api.get(`/equipment/${equipmentId}`).then((res) => res.data);

export default function useEquipment(equipmentId) {
  return useQuery(['equipments', equipmentId], () => fetchEquipment(equipmentId));
}